<template>
    <div>
        <div v-if="!loading">

                <span style="font-size: 60px; display: flex; align-items: center; justify-content: center">
                    <span v-for="error in errorMessages" style="display: flex; flex-direction: column; color:red; font-size: 20px; width: 100%">
                        {{error}}
                    </span>
                    <span v-if="errorMessages.length === 0"> {{ dailyIframeViewsGenerated}} / {{ dailyIframeViewsRequired}}</span>
                </span>

        </div>
        <div v-else class="loader" id="loader-1"></div>

    </div>
</template>

<script>
import moment from "moment";

export default {
    name: "DailyTrafficWidget",
    data() {
        return {
            loading: false,
            dailyIframeViewsGenerated: 0,
            dailyIframeViewsRequired: 0,
            errorMessages: [],
        }
    },
    created() {
        this.fetch()
    },
    methods: {
        fetch() {
            this.errorMessages = [];
            this.loading = true;

            const start = moment().utc().startOf('day').unix();
            const end = moment().utc().unix();

            axios.post('traffic-log-insights/daily-views', {
                start: start,
                end: end
            }).then((res) => {
                this.loading = false;
                this.dailyIframeViewsGenerated = res.data.daily_iframe_views_generated;
                this.dailyIframeViewsRequired = res.data.daily_iframe_views_required;
            }).catch(({response, request}) => {
                if(response.data && response.data.errors) {
                    for (const property in response.data.errors) {
                        this.errorMessages.push(response.data.errors[property][0]);
                    }
                }
                this.loading = false;
            })
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/js/admin-panel/components/widgets/DailyTraffic/DailyTrafficWidget.vue